<template>
  <div class="row documents" v-if="applicationDocuments.length > 0">
    <div class="col-md-12">
      <h4>Документы</h4>
      <div class="form-fieldhelp" style="right: 15px">
        <label>?</label>
        <div class="form-fieldhelp-text">
          <div>
            Прикрепите сканы документов в соответствующие для них разделы.
            <br/>Максимально допустимый размер файла - 2 МБ.
          </div>
        </div>
      </div>
    </div>
    <template v-for="(documentObj, documentKey) in applicationDocuments">
      <div :id="`application-document-block-${documentObj.document.id}`" :key="documentKey">
        <div class="col-md-12 col-sm-12 col-xs-12 panel-group" style="margin-bottom: 5px">
          <uppy-uploader
            v-model="application.documents[documentObj.document.short_name]"
            :dashboard-show-condition="isNew || isDuplicate || isDraft || isEdit"
            :document-comment="documentObj.comment"
            :document-key="`application-document-${documentObj.document.short_name}`"
            :document-name="documentObj.document.name"
            :document-short-name="documentObj.document.short_name"
            :documents-show-condition="isView"
            :document-need-expire="documentObj.need_expire"
            :max-files-count="documentObj.document.max_file"
            :document-id="documentObj.document.id"
            entity-type="application"
            :entity-id="application.id"
            :get-uuid="getUUID"
            :has-errors="blockHasErrors(documentObj.document.short_name)"
            :key="`application-${documentObj.document.short_name}`"
            :form="form"
            :owner-type="ownerType"
            :mime-types="$store.getters.documentValidators.find(validator => validator.id === documentObj.document.validator).mimeTypes"
            ref="uploader"
            @fileRemoved="fileRemoved"
            @change="forceUpdateForUppyUploader"
          />
          <div class="error-text" v-html="blockErrors(documentObj.document.short_name)"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient';
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin';
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import DocumentTypes from '@/common/enums/DocumentTypes';
import RusUppy from '@uppy/locales/lib/ru_RU';
import UppyUploader from '@/common/components/inputs/UppyUploader';
import VisitorDocumentListKeyItemPairHydrator from '@/common/hydrators/VisitorDocumentListKeyItemPairHydrator';

RusUppy.strings.done = 'Назад'
RusUppy.strings.noDuplicates = 'Невозможно добавить файл "%{fileName}", он уже существует.'

export default {
  name: 'ApplicationDocumentsBlock',

  components: {
    UppyUploader
  },

  mixins: [
    applicationFormMixin,
    applicationFormContextMixin
  ],

  props: {
    application: {
      type: Object,
      required: true
    },

    applicationDocuments: {
      type: [Array],
      default: () => []
    },

    form: {
      type: Object,
      default: () => ({})
    }
  },

  data: function () {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      dashboardOptions: {
        browserBackButtonClose: false,
        doneButtonHandler: null,
        height: 320,
        inline: true,
        note: 'Изображения и pdf до 2Мб',
        proudlyDisplayPoweredByUppy: false,
        showRemoveButtonAfterComplete: true,
        width: '100%'
      }
    }
  },

  computed: {
    ownerType() {
      return DocumentTypes.APPLICATION
    }
  },

  updated() {
    this.$refs?.uploader?.forEach((uppy) => {
      uppy.$forceUpdate()
    })
  },

  mounted() {
    if (this.isNew) {
      this.requestApplicationFilesOnNew()
    }
  },

  methods: {
    requestApplicationFilesOnNew() {
      new VisitorDocumentListKeyItemPairHydrator()
        .setKeyItemPairs(
          new VisitorDocumentListKeyItemPairHydrator()
            .setVisitorDocumentList(
              ApiClient
                .getLatestApplicationOrganizationDoc({ organization_inn: this.form.organization.inn })
                .then(response => ({ files: response.data?.data ?? [] }))
            )
            .hydrateKeyItemPairs()
        )
        .hydrateVisitorDocumentList()
        .then(visitorDocumentList => {
          Object.assign(this.form.application.documents, visitorDocumentList.files)
        })
    },

    blockHasErrors(field) {
      return this.hasError(this.errors.application?.documents, field)
    },

    blockErrors(field) {
      return this.getError(this.errors.application?.documents, field)?.[0]
    },

    /**
     * @param {UppyFile<UppyFileMeta, Null>} removedFile
     */
    fileRemoved(removedFile) {
      ApiClient.removeUploadedDocument({ uuid: removedFile.meta.uuid })
    },

    // TODO Analyze why the component does not register document changes in the UppyUploader without the “$forceUpdate” method and why it registers with the “$forceUpdate” method
    // TODO Remove the crutch based on the results of the analysis above
    forceUpdateForUppyUploader() {
      this.$forceUpdate()
    },

    getUUID(file) {
      return file.meta.uuid
    }
  }
}
</script>
